module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.6.5-257.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.6.5.md
// module id = 700
// module chunks = 254